import { LearningDesignSection } from '../../../../../Types';
import { findField } from '../../../../../../../../Resource/FormTemplates/Types';

export const sectionName = (section: LearningDesignSection): string => {
  return findField('name', 'string', section.template.fields)
    .map((name) => name.value)
    .getOrElseValue('');
};
export const sectionDescription = (section: LearningDesignSection): string => {
  return findField('description', 'string', section.template.fields)
    .map((name) => name.value)
    .getOrElseValue('');
};
export const sectionDisplayType = (section: LearningDesignSection): string => {
  return findField('display_type', 'string', section.template.fields)
    .map((displayType) => displayType.value)
    .getOrElseValue('');
};
export const sectionDisplayButtonLabel = (section: LearningDesignSection): string => {
  return findField('display_button_label', 'string', section.template.fields)
    .map((displayButtonLabel) => displayButtonLabel.value)
    .getOrElseValue('');
};
